export default __webpack_public_path__ + "img/eVZmDXRU.96eb4a1f.svg";